const localHeaders =
  location.hostname === 'localhost' ? { 'X-Local-Admin-Email': 'rmarietta@gmail.com' } : {};

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (!(options.body instanceof FormData)) headers.set('Content-Type', 'application/json');
  for (const [key, value] of Object.entries(localHeaders)) headers.set(key, value);
  const response = await fetch(path, {
    credentials: 'include',
    ...options,
    headers,
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error ?? `Request failed (${response.status})`);
  return body as T;
}

// For binary responses such as photos. Plain <img src> cannot send the local admin header.
export async function apiBlob(path: string): Promise<Blob> {
  const headers = new Headers();
  for (const [key, value] of Object.entries(localHeaders)) headers.set(key, value);
  const response = await fetch(path, { credentials: 'include', headers });
  if (!response.ok) throw new Error(`Request failed (${response.status})`);
  return response.blob();
}

export function usePolling(callback: () => void, milliseconds: number) {
  React.useEffect(() => {
    callback();
    const timer = window.setInterval(callback, milliseconds);
    return () => window.clearInterval(timer);
  }, [milliseconds]);
}

import React from 'react';
